// extracted by mini-css-extract-plugin
export var center = "styles-module--center--bfb7d";
export var left = "styles-module--left--d0dd2";
export var prose = "styles-module--prose--8b15d";
export var right = "styles-module--right--20d21";